import { History } from "history";

import {
  GET_PARENTS,
  GET_PARENTS_ERROR,
  GET_PARENTS_SUCCESS,
  GetParentsAction,
  GetParentsErrorAction,
  GetParentsSuccessAction,
} from "./actionTypes";
import { PaginateQuery, ParentDto } from "../../../interfaces";
import { Paginated } from "../../../models";

//#region Get Parents

export const getParents = (
  request: PaginateQuery,
  history: History
): GetParentsAction => {
  return {
    type: GET_PARENTS,
    payload: { request, history },
  };
};

export const getParentsSuccess = (
  response: Paginated<ParentDto>
): GetParentsSuccessAction => {
  return {
    type: GET_PARENTS_SUCCESS,
    payload: response,
  };
};

export const getParentsError = (error: any): GetParentsErrorAction => {
  return {
    type: GET_PARENTS_ERROR,
    payload: error,
  };
};

//#endregion
